import request from '@/utils/windyrequest';
import {errorFn, successFn} from '@/utils/windyrequestelementui';

export function aesSubmitFn(_data) {
    return request({
        headers: {
            'X-Anti-Shake': true,
        },
        url: '/api/aes/submit',
        method: 'post',
        params: null,
        data: _data,
        doNotSuccessNotification: false,
        successNotificationFn: successFn,
        errorNotificationFn: errorFn,
    })
}